import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { isLoggedIn } from '../lib/auth';

const HomePage = () => {
  const router = useRouter();

  useEffect(() => {
    // LocalStorage kontrolü
    if (isLoggedIn()) {
      router.replace('/dashboard');
    } else {
      router.replace('/login');
    }
  }, [router]);

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#F8F9FA'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        color: '#718096'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '3px solid #E2E8F0',
          borderTop: '3px solid #059669',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <span>Yönlendiriliyor...</span>
      </div>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default HomePage;